import Planning from '@/components/KitchenPlanning/Planning';
import { CaratPlanningModel } from '@/typings/models/CaratModel';
import { LeadDetailsModel } from '@/typings/models/Lead';
import React from 'react';
import styles from './CaratPlanningsDrawer.less';

export interface CaratPlanningsDrawerProps {
  plannings: CaratPlanningModel[];
  /** Pre-selected planning when the drawer was opened from a list row. */
  selectedPlanning?: CaratPlanningModel;
  leadDetails?: LeadDetailsModel;
}

/**
 * Nested drawer of the "Carat plannings" card (CLICKUP-86cb5zayy): the project's
 * kitchen planning, one panel per quotation variation. The card already loaded
 * the list, so it is handed down rather than fetched again — only the detail of
 * an opened planning is.
 */
const CaratPlanningsDrawer: React.FC<CaratPlanningsDrawerProps> = ({
  plannings,
  selectedPlanning,
  leadDetails,
}) => (
  <div className={styles.drawerContent}>
    <Planning
      plannings={plannings}
      selectedPlanning={selectedPlanning}
      leadDetails={leadDetails}
    />
  </div>
);

export default CaratPlanningsDrawer;
